import React from 'react';

const GlobalContext = React.createContext({
  sideBar: true,
});

export default GlobalContext;
